import React from 'react';
import '../../ElectricFuelPages/ElectricFuel.scss';

interface HubsViewProps {
  hubData: any;
}

const HubsView: React.FC<HubsViewProps> = ({ hubData }) => {
  const statusBadge = () => {
    if (hubData.status === 5)
      return <span className="tag is-success is-light">Active</span>;
    return <span className="tag is-danger is-light">Inactive</span>;
  };

  const cityLabel =
    typeof hubData.office_city === 'object'
      ? hubData.office_city?.label
      : hubData.office_city;

  const rolesLabel = hubData?.role
    ? hubData.role.map((r: any) => r.label).join(', ')
    : '—';

  const fields = [
    { label: 'Hub Name', value: hubData.hub_name, icon: 'fa fa-map-pin' },
    { label: 'Hub ID', value: hubData.hub_id, icon: 'fa fa-barcode' },
    { label: 'Capacity', value: hubData.hub_capacity, icon: 'fa fa-battery-full' },
    { label: 'Area', value: hubData.hub_area, icon: 'fa fa-expand' },
    { label: 'Rental', value: hubData.hub_rental, icon: 'fa fa-money' },
    { label: 'City', value: cityLabel, icon: 'fa fa-city' },
    { label: 'Access Group', value: rolesLabel, icon: 'fa fa-users' },
  ];

  return (
    <div className="p-4">
      <div className="detail-view-avatar">
        <i className="fa fa-map-marker"></i>
      </div>
      <div className="columns is-multiline">
        {fields.map((field, idx) => (
          <div className="column is-6" key={idx}>
            <div className="detail-view-field">
              <p className="detail-view-label">
                <i className={`${field.icon} mr-1`}></i> {field.label}
              </p>
              <p className="detail-view-value">{field.value || '—'}</p>
            </div>
          </div>
        ))}
        <div className="column is-6">
          <div className="detail-view-field">
            <p className="detail-view-label">
              <i className="fa fa-toggle-on mr-1"></i> Status
            </p>
            <p className="detail-view-value">{statusBadge()}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HubsView;
